import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ArrowLeftToLine } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ChatsComponent } from "@/components/pages/chats/component/ChatsComponent";
import { BookingInfoComponent } from "@/components/pages/chats/component/BookingInfoComponent";
import { useStreamChatSession } from "@/components/chat/ChatProvider";
import { ChatProfileSectionsProvider } from "@/contexts/ChatProfileSectionsContext";

const ChatsPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const activeChannel = searchParams.get("activeChannel");
  const { streamUserId, streamSessionReady } = useStreamChatSession();
  const [isInfoOpen, setIsInfoOpen] = useState(true);

  if (!streamSessionReady || !streamUserId) {
    return null;
  }

  return (
    <ChatProfileSectionsProvider>
      <div
        className={
          "flex h-full max-h-[calc(100dvh-80px)] min-h-0 flex-row overflow-hidden"
        }
      >
        <ChatsComponent
          userId={streamUserId}
          activeChannel={activeChannel}
          className={"min-w-0 flex-1"}
        />
        <motion.div
          initial={false}
          animate={{ width: isInfoOpen ? "300px" : "2.5rem" }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="flex h-full min-h-0 shrink-0 flex-col overflow-hidden"
        >
          {isInfoOpen ? (
            <BookingInfoComponent
              className={"min-h-0 w-full flex-1"}
              onCollapse={() => setIsInfoOpen(false)}
            />
          ) : (
            <div className="flex h-full w-full min-w-0 flex-col pt-4">
              <Button
                type="button"
                variant="new_ghost"
                size="icon_sm"
                className="!bg-transparent text-neutral-600"
                aria-label={t("chats.expandPanel")}
                onClick={() => setIsInfoOpen(true)}
              >
                <ArrowLeftToLine className="size-5" aria-hidden />
              </Button>
            </div>
          )}
        </motion.div>
      </div>
    </ChatProfileSectionsProvider>
  );
};

export default ChatsPage;
